import React, {PropTypes as T} from 'react';
import { findDOMNode } from 'react-dom';
import getIdentityKey from 'b3/utils/getIdentityKey'
import './style';
import { OutsideClickHandler } from 'b3';
import KeyCodes from 'b3/utils/KeyCodes';
import { Icon } from 'b3';
import Caret from 'b3/misc/Caret';
import Anchor from 'b3/anchor/Anchor'
import List from './List';

export default class Select extends React.Component {

    static propTypes = { 
        options: T.array.isRequired,
        canSelectMultiple: T.bool,
        selectedOptions: T.array, //used when canSelectMultiple == true
        selectedOption: T.any, //used when canSelectMultiple == false
        template: T.func,
        identityKey: T.any,
        onSearchTextChanged: T.func,
        onOptionSelected: T.func,
        onOptionDeselected: T.func,
        placeholder: T.string,
        canFilter: T.bool,
        showCaret: T.bool,
        canDeselect: T.bool,
        className: T.string,
        dropdownPosition: T.string,
        dropdownAlign: T.string,
    };

    static defaultProps = {
        canSelectMultiple: false,
        selectedOptions: [],
        onSearchTextChanged: () => {},
        onOptionSelected: () => {},
        onOptionDeselected: () => {},
        placeholder: 'Select an option',
        canFilter: true,
        showCaret: true,
        canDeselect: true,
        className: 'b3-select',
        onFocus: function() {},
        onBlur: function() {},
        dropdownPosition: 'bottom',
        dropdownAlign: 'both',
        size: 20
    };

    constructor(props) {
        super(props);

        this.state = {
            dropdownShown: false,
            focussedOption: null,
            searchText: '',
        }
    }

    renderOption(option) {
        return this.props.template ? this.props.template(option) : option.toString();
    }

    handleKeyDown(event) {

        if (event.keyCode == KeyCodes.ENTER) {
            this.refs.list.selectFocussed(event);
        }
        else if (event.keyCode == KeyCodes.UP) {
            this.refs.list.focusPrevious();
        }
        else if (event.keyCode == KeyCodes.DOWN) {
            this.refs.list.focusNext();
        }
        else if (event.keyCode == KeyCodes.BACKSPACE) {

            if (this.refs.searchText.value.length == 0)
            {
                if (this.props.canSelectMultiple && this.props.selectedOptions.length > 0) {
                    var toRemove = this.props.selectedOptions.slice(-1)[0];
                    this.props.onOptionDeselected(toRemove);
                }
                else if (!this.props.canSelectMultiple && this.props.selectedOption) {
                    this.props.onOptionDeselected(this.props.selectedOption);
                }

            }
            
        }
        else {
            this.setState({ dropdownShown: true });
            this.props.onFocus();
        }

    }

    handleEnter(event) {
        this.selectOption(this.state.focussedOption);
    }

    handleMainClick(event) {

        if (this.props.canFilter)
        {

            if (event.target == findDOMNode(this.refs.searchText)) {
                this.refs.searchText.select();
            }
            else {

                if (this.refs.searchText) {
                    this.refs.searchText.selectionEnd = this.refs.searchText.value.length;
                    this.refs.searchText.selectionStart = this.refs.searchText.value.length;
                    this.refs.searchText.focus(); 
                }

            }
 
        }

        if (!this.state.dropdownShown) {
            this.setState({ dropdownShown: true });
            this.props.onFocus();
        }
        
    }

    handleInputChange(event) {
        this.setState({ searchText: event.target.value });
        this.props.onSearchTextChanged(event.target.value);
    }

    handleOutsideClick() {
        this.setState({ dropdownShown: false });
        this.props.onBlur();
    }

    handleOptionSelected(option) {
        this.setState({ dropdownShown: false, searchText: '' });
        this.props.onBlur();
        this.props.onOptionSelected(option);
        this.props.onSearchTextChanged();
    }

    handleOptionDeselected(option) {
        this.props.onOptionDeselected(option);
    }

    shouldShowPlaceholder() {
        return !this.state.dropdownShown
            && this.state.searchText.length == 0
            && (
                (this.props.canSelectMultiple && this.props.selectedOptions.length == 0)
                || (!this.props.canSelectMultiple && !this.props.selectedOption)
            );
    }

    shouldShowInput() {
        return this.props.canFilter
        && (
            this.props.canSelectMultiple
            || (!this.props.canSelectMultiple && this.props.selectedOption == null)
        );
    }

    handleDeselectClick(option, event) {
        this.props.onOptionDeselected(option);
        event.stopPropagation();
    }

	render() {

        return (

            <div className={this.props.className}>

                <div ref={el => {this.dropdown = el}} className="b3-select-main" onClick={this.handleMainClick.bind(this)}>

                    <div className="b3-select-main-inner">

                        {this.shouldShowPlaceholder() &&
                            <span className="b3-select-placeholder">{this.props.placeholder}</span>
                        }

                        {this.props.canSelectMultiple && this.props.selectedOptions.length > 0 && this.props.selectedOptions.map(option => 

                            <div key={getIdentityKey(option, this.props.selectedOptions, this.props.identityKey)} className="b3-select-option">

                                <a className="b3-select-option-deselect" onClick={this.handleDeselectClick.bind(this, option)}>
                                    <Icon icon="cross" />
                                </a>

                                <div>{this.renderOption(option)}</div>

                            </div>

                        )}

                        {!this.props.canSelectMultiple && this.props.selectedOption &&
                            <span className="b3-select-value">{this.renderOption(this.props.selectedOption)}</span>
                        }

                        {this.shouldShowInput() &&
                            <input className="b3-select-input" size={this.state.searchText.length ? this.state.searchText.length + 2 : 1} ref="searchText" type="text" value={this.state.searchText} onKeyDown={this.handleKeyDown.bind(this)} onChange={this.handleInputChange.bind(this)} />
                        }

                    </div>

                    {this.props.canDeselect && !this.props.canSelectMultiple && this.props.selectedOption &&
                        <a className="b3-select-deselect" onClick={this.handleDeselectClick.bind(this)}><Icon icon="cross" /></a>
                    }

                    {this.props.showCaret &&
                        <Caret expanded={true} size={this.props.size} />
                    }

                </div>

                {this.state.dropdownShown &&

                    <Anchor target={this.dropdown} position={this.props.dropdownPosition} align={this.props.dropdownAlign}>

                    	<OutsideClickHandler onOutsideClick={this.handleOutsideClick.bind(this)}>
                    
                    		<div className="b3-select">

		                        <div className="b3-select-anchor">

		                            {this.props.options.length > 0 &&
		                                <List ref="list" options={this.props.options} onOptionSelected={this.handleOptionSelected.bind(this)} template={this.props.template} identityKey={this.props.identityKey} />
		                            }

		                            {this.state.searchText && this.props.options.length == 0 &&
		                                <div className="b3-select-empty">
		                                    <Icon icon="delete-1" />
		                                    <span>No items found</span>
		                                </div>
		                            }

		                        </div>

	                        </div>

                        </OutsideClickHandler>
                        
                    </Anchor>


                }


            </div>
        )
	}
}


// WEBPACK FOOTER //
// ./app/b3/select/Select.js